import { loadPdfJobs, setFilters, setOrdering } from "@store/actions/pdf";
import { getFilters, getOrdering } from "@store/selectors/pdf";
import { AvailableFilters } from "@utils/enums";
const pdfJobsMiddleware = ({ dispatch, getState }) => (next) => (action) => {
    const { payload, type } = action;
    if (type === "ADD_FILTER" ||
        type === "REMOVE_FILTER") {
        let filters = {};
        const currentFilters = getFilters(getState());
        if (type === "ADD_FILTER") {
            const filtersToSet = payload;
            filters = { ...currentFilters, ...filtersToSet };
        }
        if (type === "REMOVE_FILTER") {
            filters = Object.keys(currentFilters).reduce((object, key) => {
                if (key !== payload) {
                    const value = currentFilters[key];
                    object = {
                        ...object,
                        [key]: value
                    };
                }
                if (payload === AvailableFilters.CREATED_FROM) {
                    delete object[AvailableFilters.CREATED_TO];
                }
                if (payload === AvailableFilters.UPDATED_FROM) {
                    delete object[AvailableFilters.UPDATED_TO];
                }
                return object;
            }, {});
        }
        dispatch(setFilters(filters));
        dispatch(loadPdfJobs({ PageNumber: 1 }));
    }
    if (type === "CHANGE_ORDERING_DIRECTION" ||
        type === "CHANGE_ORDERING_KEY") {
        const currentOrdering = getOrdering(getState());
        let ordering = {};
        if (type === "CHANGE_ORDERING_DIRECTION") {
            ordering = {
                ...currentOrdering,
                Ascending: !currentOrdering.Ascending
            };
        }
        if (type === "CHANGE_ORDERING_KEY") {
            ordering = {
                ...currentOrdering,
                OrderBy: payload
            };
        }
        dispatch(setOrdering(ordering));
        dispatch(loadPdfJobs({ PageNumber: 1 }));
    }
    return next(action);
};
export default pdfJobsMiddleware;
